export default {
  Menu: {
    account: 'Account',
    alterar_conta: 'Change account',
    trocar_senha: 'Change password',
    gerenciar_usuarios: 'Manage profile',
    indique_ganhe: 'Refer and earn',
    about_the_user: 'Your user',
    alterar_idioma: 'Change language',
    config_area: 'Configure area',
    users: 'Users',
    edit_user: 'Edit user',

    PasswordModal: {
      type_here: 'Type here',
      current_password: 'Current password',
      new_password: 'New password',
      confirm_password: 'Confirm password',
    },
  },
}
